
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  //siteUrl: string = 'https://localhost:44324/'; // Local server
  //siteUrl: string = 'http://localhost:9095/'; // Development server
  

  //siteUrl: string = 'http://tatvahillsadmin.tatvahills.com/API/' //UAT server
  //PaymentResponseUrl: string ="http://tatvahillsadmin.tatvahills.com/api/Home/PaymentResponse"; // UAT server
  
  siteUrl: string = 'https://www.tatvahills.com/api/' //Production server
  PaymentResponseUrl: string ="https://www.tatvahills.com/api/Home/PaymentResponse"; //Production server

  constructor(private http: HttpClient) { }

  get<T>(url): Observable<T> {
    return this.http.get<T>(this.siteUrl + url);
  }

  getWithTokenHeaders(url, token): any {
    //return this.http.get(this.siteUrl + url, headers);
    return this.http.get(this.siteUrl + url, { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + token }) });
  }

  getWithHeaders(url, headers): any {
    return this.http.get(this.siteUrl + url, headers);
  }

  post<T>(url, body): any {
    return this.http.post<T>(this.siteUrl + url, body);
  }

  postWithHeader(url, body, headers): any {
    return this.http.post(this.siteUrl + url, body, headers);
  }

  put<T>(url, body): any {
    return this.http.put<T>(this.siteUrl + url, body);
  }

  delete<T>(url): any {
    return this.http.get<T>(this.siteUrl + url);
  }
}
